import { ContentSwitcher } from '@app/components/various/ContentSwitcher';
import { DesktopBig, MobileBig, TabletBig } from '@app/components/various/Icons';
import { Cms } from '@typings';

interface Props {
  onChange: (type: Cms.ScreenType) => void;
  value: Cms.ScreenType;
  groupName: string;
  className?: string;
}

const options = [
  {
    className: 'hidden lg:flex',
    icon: DesktopBig,
    value: 'desktop',
  },
  {
    icon: TabletBig,
    value: 'tablet',
  },
  {
    icon: MobileBig,
    value: 'mobile',
  },
];

export const DeviceSwitcher = ({ onChange, value, groupName, className }: Props) => {
  return (
    <ContentSwitcher tabs={options} groupName={groupName} selectedValue={value} onChange={onChange} variant="gray" className={className} />
  );
};
